import { apiClient } from "./httpClient";
import { EmploymentHistory, EmploymentPeriod, RehirePayload } from "./types";

const USERS_URL = `${process.env.REACT_APP_API_URL}/users`;
const EMPLOYMENT_PERIODS_URL = `${process.env.REACT_APP_API_URL}/employment-periods`;

export const getEmploymentHistory = async (
  userId: number,
): Promise<EmploymentHistory> => {
  const response = await apiClient.get(
    `${USERS_URL}/${userId}/employment-history`,
  );
  return response.data as EmploymentHistory;
};

// endDate: last working day, YYYY-MM-DD.
export const terminateEmployment = async (
  userId: number,
  endDate: string,
): Promise<EmploymentPeriod> => {
  const response = await apiClient.post(`${USERS_URL}/${userId}/terminate`, {
    endDate,
  });
  return response.data as EmploymentPeriod;
};

export const rehireEmployee = async (
  userId: number,
  payload: RehirePayload,
): Promise<EmploymentPeriod> => {
  const response = await apiClient.post(
    `${USERS_URL}/${userId}/rehire`,
    payload,
  );
  return response.data as EmploymentPeriod;
};

export const updateEmploymentPeriod = async (
  periodId: number,
  payload: { employeeCode: string; startDate: string; endDate: string | null },
): Promise<EmploymentPeriod> => {
  const response = await apiClient.put(
    `${EMPLOYMENT_PERIODS_URL}/${periodId}`,
    payload,
  );
  return response.data as EmploymentPeriod;
};

export const updateEmploymentPeriodBalance = async (
  periodId: number,
  year: number,
  payload: { currentYearDays: number; previousYearDays: number },
): Promise<EmploymentPeriod> => {
  const response = await apiClient.put(
    `${EMPLOYMENT_PERIODS_URL}/${periodId}/balances/${year}`,
    payload,
  );
  return response.data as EmploymentPeriod;
};
